/**
 * Given on the state, set the right variation on the product
 */

export default function variantConnector(store) {
    let {input, ringSize, goldColor} = store.getState();

    if (!/au/.test(location.hostname)) {
        console.warn('Variant connector is off in local environment');
    }

    let sku = `au-letter-ring-${input.length}`;

    if (!window.productVariants) {
        console.error(sku);
        throw new Error('Product variants hash is missing in window object');
    }

    let selectedVariant = window.productVariants.find((variant) => variant.sku === sku);

    /** Code below mimics product-options code **/

    timber.productPage({
        variant: selectedVariant
    });

    if (selectedVariant) {
        document.querySelector("[data-js='master-select']").value = selectedVariant.id;
        document.getElementById('gold-color').value = goldColor.description;
        document.getElementById('ring-size').value = ringSize;
        document.getElementById('ring-text').value = input.toUpperCase();

        if (window.affirm) {
            window.affirm.ui.ready(function () {
                if (document.querySelector('.affirm-as-low-as')) {
                    document.querySelector('.affirm-as-low-as').setAttribute('data-amount', selectedVariant.price);
                    window.affirm.ui.refresh();
                }
            });
        }

        window.selectedVariant = selectedVariant.title;
    }
}
